/* eslint-disable */
import { GetterTree } from "vuex";
import { Department } from "@/models/department";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { DepartmentState } from "@/types/department";

const getters: GetterTree<DepartmentState, RootState> = {
  list: state => {
    return state.pagination ? state.pagination.data : [];
  },
  pagination: state => {
    return state.pagination || new Pagination();
  },
  single: state => {
    return state.single || new Department();
  },
  selectItem: state => {
    return state.pagination
      ? state.pagination.data.map(department =>
          Department.toSelectItem(department)
        )
      : [];
  },
  find: state => (id: number) => {
    return state.pagination
      ? state.pagination.data.find(department => {
          return department.id == id;
        })
      : new Department();
  }
};

export default getters;
